import { useState } from 'react';
import { WidgetProps } from '@rjsf/core';

const Slider = (props: WidgetProps) => {
    const { schema, value, onChange } = props;
    const [sliderValue, setSliderValue] = useState(value || '100');

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSliderValue(`${e.target.value}`);
        onChange(`${e.target.value}%`);
    };

    const backgroundSize = `${
        ((parseInt(sliderValue.replace('%', '')) - 0) * 100) / (100 - 0)
    }% 100%`;

    return (
        <div className="slider-container">
            <div className="slider-content">
                <label className="slider-label">{schema.title}</label>
                <p className="slider-value">{`${sliderValue.replace('%', '')}%`}</p>
            </div>
            <input
                type="range"
                onChange={onChangeHandler}
                className="slider"
                min="0"
                max="100"
                step="1"
                value={sliderValue.replace('%', '')}
                style={{ backgroundSize }}
            />
        </div>
    );
};

export default Slider;
